import { UcoastEl } from '@/scripts/core/UcoastEl'
import { debounce } from '@/scripts/core/global'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { Filters } from '@/scripts/interactive-defer/filters'

export class FilterForm extends UcoastEl {
	static htmlSelector = 'filter-form'
	debouncedOnSubmit: (event: Event) => void
	constructor() {
		super()
		if (!window.Filters) {
			window.Filters = new Filters()
		}

		this.debouncedOnSubmit = debounce((event: InputEvent) => {
			this.onSubmitHandler(event)
		}, 400)

		const facetForm = q.rs<HTMLFormElement>('form', this)
		facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this))
	}
	createSearchParams(form: HTMLFormElement) {
		const formData = new FormData(form)
		return new URLSearchParams(formData).toString()
	}

	onSubmitForm(searchParams: string, event: InputEvent) {
		Filters.renderPage(searchParams, event)
	}

	onSubmitHandler(event: InputEvent) {
		event.preventDefault()
		const sortFilterForms = q.ol<HTMLFormElement>('filter-form form')
		const forms: string[] = []

		sortFilterForms?.forEach((form) => {
			forms.push(this.createSearchParams(form))
		})
		this.onSubmitForm(forms.join('&'), event)
	}
}
